module.exports = __webpack_public_path__ + "img/img1.32b901c7.png";